import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function AdminContactMessages() {
  const [rows, setRows] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/contact-messages"); setRows(data); };
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { await api.post(`/admin/contact-messages/${id}/status`, { status }); load(); };

  const sb = (s) => {
    const map = { new: "bg-amber-100 text-amber-700", read: "bg-blue-100 text-blue-700", replied: "bg-emerald-100 text-emerald-700" };
    return <Badge className={`${map[s] || "bg-slate-100 text-slate-700"} border-0 capitalize`}>{s}</Badge>;
  };

  return (
    <div>
      <h1 className="font-heading text-3xl font-semibold text-[var(--brand-accent)]">Contact messages</h1>
      <p className="text-slate-500 mt-1">Submissions from the Contact Us form.</p>
      <Card className="mt-5 overflow-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Name</TableHead><TableHead>Email</TableHead><TableHead>Subject</TableHead><TableHead>Message</TableHead><TableHead>Status</TableHead><TableHead>Date</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id} data-testid={`msg-row-${r.id}`}>
                <TableCell className="font-medium">{r.name}</TableCell>
                <TableCell className="text-xs">{r.email}{r.phone ? ` · ${r.phone}` : ""}</TableCell>
                <TableCell>{r.subject || "—"}</TableCell>
                <TableCell className="text-xs text-slate-600 max-w-md truncate">{r.message}</TableCell>
                <TableCell>{sb(r.status)}</TableCell>
                <TableCell className="text-xs text-slate-500">{new Date(r.created_at).toLocaleString()}</TableCell>
                <TableCell>
                  {r.status !== "replied" && <Button size="sm" variant="outline" onClick={() => setStatus(r.id, "replied")}>Mark replied</Button>}
                </TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-slate-400 py-10">No messages</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
